import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import {
  columnCreatedOn,
  columnDescription,
  columnMultiSelect,
  columnNameLink,
  columnStatus,
  columnTools,
  columnUpdatedOn,
  columnVisibility,
} from '@/constants/fields';
import { presentationOptions } from '@/constants/states';
import paging, { onCategoryScroll } from '@/hooks/paging';
import CardsHeader from '@/components/cards/CardsHeader';
import CohortsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/CohortsPanelContainer';
import CohortsTable from '../components/CohortsTable';
import CohortCards from '../components/CohortCards';
import CohortsFilters from './CohortsFilters';

const buildColumns = (allowStatus) => {
  const columns = [columnMultiSelect,
    columnNameLink,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnVisibility,
    columnTools];
  if (allowStatus) {
    columns.push(columnStatus);
  }
  return columns;
};

const CohortsPanelFull = ({
  allowStatus,
  canCreate,
  canRead,
  category,
  cohorts,
  currentPage,
  display,
  fetchData,
  onCheckBoxClick,
  newCohortCode,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  total,
  togglePresentation,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus);

  return (
    <CohortsPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-cohorts-panel-full">
      {display === presentationOptions.CARDS && (
      <>
        <CardsHeader
          disabled={readStatus === states.PENDING}
          onClick={() => togglePresentation(category, presentationOptions.TABLE)}
        >
          <CohortsFilters category={category} className="aridhia-list-filter" />
        </CardsHeader>
        <CohortCards
          canCreate={canCreate}
          category={category}
          handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
          items={cohorts}
          newCohortCode={newCohortCode}
          onCheckBoxClick={(value) => onCheckBoxClick(category, value)}
          readErrors={readErrors}
          readStatus={readStatus}
        />
      </>
      )}
      {display !== presentationOptions.CARDS && (
      <CohortsTable
        canCreate={canCreate}
        category={category}
        cohorts={cohorts}
        columns={buildColumns(allowStatus)}
        currentPage={currentPage}
        fetchData={fetchData}
        newCohortCode={newCohortCode}
        onCheckBoxClick={(value) => onCheckBoxClick(category, value)}
        pageCount={pageCount}
        pageSize={pageSize}
        readErrors={readErrors}
        readStatus={readStatus}
        togglePresentation={togglePresentation}
        total={total}
      />
      )}
    </CohortsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortsPanelFull);
